import { cx } from './cx';

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg' | undefined;
  /**
   * Announced to a screen reader, and rendered as text when `center` is set.
   * Without it the spinner is `aria-hidden` — a decorative one inside a button
   * whose label already says "Saving" should not be read out twice.
   */
  label?: string | undefined;
  /** Fills its container and centres, for a route that is still loading. */
  center?: boolean | undefined;
  className?: string | undefined;
}

export function Spinner({ size = 'md', label, center = false, className }: SpinnerProps) {
  const circle = (
    <span
      className={cx('dc-spinner', `dc-spinner--${size}`, !center && className)}
      role={label === undefined ? 'presentation' : 'status'}
      aria-hidden={label === undefined}
      aria-label={label}
    />
  );

  if (!center) return circle;

  return (
    <div className={cx('dc-spinner-block', className)}>
      {circle}
      {label !== undefined && <span className="dc-spinner-block__label">{label}</span>}
    </div>
  );
}
